import React from 'react';
import { Text, TextType } from 'ui-components/components/text';
import messages from './messages';

export const ShopperBulletDeliveryRestriction = () => <Text textType={TextType.H4} value={messages.shopperBulletDeliveryRestriction} />;
